import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import Paper from 'material-ui/Paper';

import {
    RadioButton,
    RadioButtonGroup,
} from 'material-ui/RadioButton';
import { withRouter } from 'react-router-dom';

import {
    Utils,
    projetoService,
    tipoSubmissaoService,
    arquivoService,
} from '../../services';
import { Load } from '../../components';

const styles = {
    content: {
        padding: 16,
    },
};

class InscricaoStepTema extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            carregando: false,
            titulo: '',
            instituicao: 'SETREM',
            tipo: 0,
            arquivo: [],
            tituloValido: true,
            dsTiposSubmissao: [],
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        this.csrfToken = (await arquivoService.arquivoForm()).token;
        await this.buscaTiposSubmissao(this.props.subevento);
    }

    onSelectChange(tipo) {
        this.setState({ tipo });
    }

    onChangeArquivo(event) {
        const arquivo = event.target.files[0];
        this.setState({ arquivo });
    }

    async onSalvarTema(event) {
        event.preventDefault();
        this.setState({ carregando: true });
        const {
            titulo,
            instituicao,
            tipo,
            arquivo,
        } = this.state;

        try {
            const response = await arquivoService.validarQuantidadeDePaginas(arquivo, tipo, this.csrfToken);
            if (response.valido) {
                this.props.onInformarTemaProjeto(titulo, instituicao, tipo, arquivo);
                return;
            }
            Utils.showToast(response.message);
        } catch (_) {
            Utils.showToast('Não foi possível validar o arquivo.');
        }
        this.setState({ carregando: false });
    }

    async verificarSeProjetoJaExiste(titulo) {
        if (titulo) {
            const projeto = await projetoService.getTituloProjeto(titulo, this.props.subevento);
            this.setState({ tituloValido: !projeto.existeProjeto });
        }
    }

    async buscaTiposSubmissao(subevento) {
        const tiposSubmissao = await tipoSubmissaoService.getTiposSubmissao(subevento);
        this.setState({ dsTiposSubmissao: tiposSubmissao });
        Utils.showLoading(false);
    }

    render() {
        const {
            carregando,
            titulo,
            instituicao,
            tipo,
            arquivo,
            tituloValido,
            dsTiposSubmissao,
        } = this.state;
        const isTodosCamposValidos = !!titulo && !!instituicao && !!tipo && tituloValido && !!arquivo;

        let errorTextTitulo = '';
        if (!tituloValido) {
            errorTextTitulo = 'Um projeto com este título já foi inscrito neste subevento.';
        } else if (!titulo) {
            errorTextTitulo = 'Campo obrigatório';
        }

        return (
            <div style={styles.content}>
                {carregando && <Load />}
                <form onSubmit={e => this.onSalvarTema(e)}>
                    <TextField
                        floatingLabelText="Título"
                        value={titulo}
                        onChange={e => this.setState({ titulo: e.target.value })}
                        errorText={errorTextTitulo}
                        maxLength={500}
                        onBlur={e => this.verificarSeProjetoJaExiste(e.target.value)}
                        fullWidth
                        required
                    />
                    <br />
                    <TextField
                        floatingLabelText="Instituição"
                        value={instituicao}
                        onChange={e => this.setState({ instituicao: e.target.value })}
                        errorText={instituicao ? '' : 'Campo obrigatório'}
                        maxLength={200}
                        fullWidth
                        required
                        disabled={instituicao == "SETREM"}
                    />
                    <Toggle
                        label="Instituição SETREM"
                        style={styles.toggle}
                        defaultToggled={true}
                        onToggle={(e, checked) => this.setState({ instituicao: (checked ? "SETREM" : "") })}
                        labelPosition="right"
                    />
                    <br />
                    <p>Selecione o tipo de submissão:</p>
                    <RadioButtonGroup
                        name="tipoSubmissao"
                        value={tipo}
                        onChange={(event, t) => this.onSelectChange(t)}
                    >
                        {
                            dsTiposSubmissao.map(x => <RadioButton key={x.CODIGO} value={x.CODIGO} label={x.DESCRICAO} />)
                        }
                    </RadioButtonGroup>
                    <br />
                    <p>Faça upload de seu arquivo PDF:</p>
                    <RaisedButton
                        containerElement="label"
                    >
                        <input
                            type="file"
                            accept="application/x-pdf"
                            onChange={event => this.onChangeArquivo(event)}
                            required
                        />
                    </RaisedButton>
                    <br />
                    <br />
                    <Paper style={{
                        height: 40,
                        width: 350,
                        padding: 10,
                        fontWeight: 'bold',
                        color: 'red',
                        display: 'inline-block',
                    }} zDepth={2}>OBS: Apenas serão aceitos arquivos PDF </Paper>
                    <br />
                    <br />
                    <br />
                    <RaisedButton
                        label="Avançar"
                        primary
                        type="submit"
                        disabled={!isTodosCamposValidos}
                    />
                </form>
            </div>
        );
    }
}

InscricaoStepTema.propTypes = {
    onInformarTemaProjeto: PropTypes.func.isRequired,
    subevento: PropTypes.number.isRequired,
};

export default withRouter(InscricaoStepTema);
